<template>
  <el-dialog
    class="sure-pay-dialog"
    :title="title"
    :visible="dialogShow"
    :before-close="handleClose"
  >
    <div
      class="inner">
      <div class="line-flex-row">
        <div class="left-text">{{$t('Amount_deposited')}}</div>
        <div class="line-el"></div>
        <span class="right-data">{{onlinePayInfo.amount}} USD</span>
      </div>
      <div class="line-flex-row">
        <div class="left-text">{{$t('User.fee')}}</div>
        <div class="line-el"></div>
        <span class="right-data">{{onlinePayInfo.fee}} USD</span>
      </div>
      <div class="line-flex-row">
        <div class="left-text">{{$t('Payment_currency')}}</div>
        <div class="line-el"></div>
        <span class="right-data">{{onlinePayInfo.currency}}</span>
      </div>
      <div class="line-flex-row">
        <div class="left-text">{{$t('Trade.payMoney')}}</div>
        <div class="line-el"></div>
        <span class="right-data">{{onlinePayInfo.totalAmount}} {{onlinePayInfo.currency}}</span>
      </div>
    </div>
    <div class="sure-footer">
      <el-button
        class="text-btn"
        @click="cancel" type="text">{{ $t('cancel') }}</el-button>
<!--      <vs-button @click="submitHandle">{{$t('confirm')}}</vs-button>-->
      <template v-if="onlinePayInfo.channelName != 'perfectmoney'">
        
        <!--   支付宝和购币支付app和h5直接跳转页面，不会用内嵌iframe方式显示入金界面-->
        <div
          v-if="getIsApp()&&onlinePayInfo.channelName != 'OfaPay'&&onlinePayInfo.channelName != 'OTC365-CoinPay'"
          @click="appInnerSubmitHandle"
          class="mockbtn pointer"
        >
          <a
            class="url-link"
          >
            <el-button
              type="primary"
              class="submit-btn">
              {{$t('root.confirm')}}
            </el-button>
          </a>
        </div>
        <div
          v-else
          @click="submitHandle"
          class="mockbtn pointer"
        >
          <a
            class="url-link"
            :href="onlinePayInfo.url" target="_blank">
            <el-button
              type="primary"
              class="submit-btn">
              {{$t('root.confirm')}}
            </el-button>
            <!--                    <input-->
            <!--                            type="submit" class="fivepay-submitbtn" id="fivepaybtn" :value="$t('root.confirm')">-->
          </a>
        </div>

      </template>
      <template v-else>
        <slot></slot>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import { getIsApp } from '@/utils';
export default {
  name: "sureDialog",
  props: {
    dialogShow:{
      type: Boolean,
      default: false,
    },
    onlinePayInfo: {
      type: Object,
      default(){
        return {
          amount: '',
          fee: '',
          currency: '',
          totalAmount: '',
          url: '',
        }
      }
    },
  },
  data() {
    let _this = this;
    return {
      title: _this.$t('Confirm_payment_information'),
    }
  },
  computed: {
  },
  methods: {
    getIsApp,
    handleClose(){
      this.close();
    },
    close() {
      this.$emit('close')
    },
    cancel(){
      this.close();
    },
    submitHandle(){
      this.$emit('formsubmit');
    },
    appInnerSubmitHandle(){
      this.$emit('jump-matchUniDeposit')
    }
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/variable";
.sure-pay-dialog {
  .mockbtn {
    display: inline-block;
  }
  .line-flex-row {
    font-size: 14px;
    margin-bottom: 10px;
    .left-text {
      color: #A29FAE;
    }
  }
  .text-btn {
    padding-right: 20px;
  }
  .sure-footer {
    margin-top: 20px;
    text-align: right;
  }

}
</style>
<style lang="scss">
.sure-pay-dialog {
  .vs-popup {
    width: 400px!important;
  }
}
</style>
